import { useSelector } from 'react-redux';
import { getIsYearFilter, getStorageSelectedItems } from 'reactApp/modules/storage/storage.selectors';
import { CloudItem, EActions, EStorageType } from 'reactApp/modules/storage/storage.types';
import { RootState } from 'reactApp/store';
import { getBackItem } from 'reactApp/ui/Toolbar/customActions/getBackItem';
import { getDeleteItem } from 'reactApp/ui/Toolbar/customActions/getDeleteItem';
import { TOOLBAR_CONFIG } from 'reactApp/ui/Toolbar/Toolbar.config';
import { TToolbarItem } from 'reactApp/ui/Toolbar/Toolbar.types';

import { getYearFilterItem } from './getYearFilterItem';

export const useCustomActions = ({ storage }: { storage: EStorageType }) => {
    const left: TToolbarItem[] = [];
    const right: TToolbarItem[] = [];

    const items: CloudItem[] = useSelector((state: RootState) => getStorageSelectedItems(state, storage)) as CloudItem[];
    const isYearFilter = useSelector(getIsYearFilter);

    const settings = TOOLBAR_CONFIG[storage];
    if (!settings) {
        return { left, right };
    }

    if (settings.back) {
        left.push(getBackItem(storage));
    }

    if (settings[EActions.yearFilter] && isYearFilter) {
        right.push(getYearFilterItem(storage));
    }

    if (settings.delete) {
        right.push(getDeleteItem(storage, items));
    }

    return { left, right };
};
